import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/ForumCrestest.css";

// Import required asset paths (adjust paths based on your file structure)
import featureSectionBg2 from "../../images/Banner2.png";
import Why1 from "../../images/why1.png";
import Why2 from "../../images/why2.png";
import Why3 from "../../images/why3.png";
import Why4 from "../../images/why4.png";
import bottomCornerImg from "../../images/forum-dash1.png"; // Repositioned to bottom center

function ForumCrestest() {
    const navigate = useNavigate();

    return (
        <section className="forum-grid-bg-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
            {/* Bottom Center Positioned Image Asset */}
            <div className="forum-bottom-corner-wrapper">
                <img
                    src={bottomCornerImg}
                    alt="Center Bottom Decoration"
                    className="forum-bottom-corner-image"
                />
            </div>

            <div className="container forum-content-layer">

                {/* Centralized Section Header */}
                <div className="row justify-content-center text-center mb-5">
                    <div className="col-lg-8">
                        <span className="forum-grid-mini-tag">CRESTEST FORUM</span>
                        <h2 className="forum-grid-heading">
                            Learn, Discuss & Grow Together
                        </h2>
                        <div className="forum-zigzag-border mx-auto mt-3"></div>
                    </div>
                </div>

                {/* 2 Cards Per Row */}
                <div className="row g-4 justify-content-center mb-5">

                    {/* Share & Ask */}
                    <div className="col-lg-6">
                        <div className="forum-glass-box">
                            <div className="forum-box-inner">
                                <div className="forum-square-icon-wrapper forum-accent-blue">
                                    <img
                                        src={Why1}
                                        alt="Ask & Share"
                                        className="forum-panel-image"
                                    />
                                </div>

                                <div className="forum-box-text-block">
                                    <h4>Ask, Share & Learn</h4>
                                    <p>
                                        Share your ideas, ask academic questions, and receive verified guidance
                                        from Crestest moderators as well as experienced students and subject experts.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Connect */}
                    <div className="col-lg-6">
                        <div className="forum-glass-box">
                            <div className="forum-box-inner">
                                <div className="forum-square-icon-wrapper forum-accent-yellow">
                                    <img
                                        src={Why2}
                                        alt="Connect"
                                        className="forum-panel-image"
                                    />
                                </div>

                                <div className="forum-box-text-block">
                                    <h4>Connect & Collaborate</h4>
                                    <p>
                                        Connect with students across schools, join meaningful discussions,
                                        exchange ideas, and learn together in a supportive academic community.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quiz Arena */}
                    <div className="col-lg-6">
                        <div className="forum-glass-box">
                            <div className="forum-box-inner">
                                <div className="forum-square-icon-wrapper forum-accent-teal">
                                    <img
                                        src={Why3}
                                        alt="Quiz Arena"
                                        className="forum-panel-image"
                                    />
                                </div>

                                <div className="forum-box-text-block">
                                    <h4>Play & Challenge</h4>
                                    <p>
                                        Participate in exciting quizzes, challenge your friends,
                                        improve your knowledge, and climb the leaderboard while learning.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Personalized Feed */}
                    <div className="col-lg-6">
                        <div className="forum-glass-box">
                            <div className="forum-box-inner">
                                <div className="forum-square-icon-wrapper forum-accent-teal">
                                    <img
                                        src={Why4}
                                        alt="Personalized Feed"
                                        className="forum-panel-image"
                                    />
                                </div>

                                <div className="forum-box-text-block">
                                    <h4>Personalized Feed</h4>
                                    <p>
                                        Enjoy a customized feed that shows discussions, questions,
                                        and posts based on your interests, subjects, and learning preferences.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Center Aligned Redirect Button */}
                <div className="row justify-content-center">
                    <div className="col-auto">
                        <button
                            className="forum-redirect-btn"
                            onClick={() => navigate('/forum')}
                        >
                            Explore Forum
                        </button>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default ForumCrestest;

